// WebSocket client-to-server request type IDs
export const WS_CLIENT_AUTH = 1;
export const WS_CLIENT_SUBSCRIBE_IN_RANGE_PLAYERS = 2;
export const WS_CLIENT_UNSUBSCRIBE_IN_RANGE_PLAYERS = 3;
// Add more as needed
